import { render, staticRenderFns } from "./msw-atp-training.vue?vue&type=template&id=dc9bff24&"
import script from "./msw-atp-training.vue?vue&type=script&lang=tsx&"
export * from "./msw-atp-training.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-atp-training.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports